import { Snackbar, Alert } from "@mui/material";
import _ from "lodash";

const CustomAlert = ({
  show,
  message,
  duration = 6000,
  error,
  severity,
  keepOpen,
  alwaysVisible,
  ...props
}) => {
  const onSnackbarClose = (event, reason) => {
    if (reason === "clickaway" || keepOpen) {
      return;
    }

    const { onClose = _.identity } = props;
    onClose(event, reason);
  };

  const autoHideDuration = alwaysVisible ? null : duration;

  return (
    <Snackbar
      autoHideDuration={autoHideDuration}
      severity={severity}
      open={show || !_.isEmpty(error)}
      onClose={onSnackbarClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      sx={{ mt: { xs: 5, sm: 5, md: 0 } }}
    >
      <Alert severity={severity} sx={{ width: "100%" }} {...props}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default CustomAlert;
